import * as React from 'react';

const LinearChart = ({ percentage }) => {
  return (
    <svg width='180' height='8' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient id='colorGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset={`${percentage}%`} stopColor='#E00034' />
          <stop offset={`${percentage - 100}%`} stopColor='#EBEBEB' />
        </linearGradient>
      </defs>

      <rect x='0' y='0' width='100%' height='8' fill={'url(#colorGradient)'} />
    </svg>
  );
};

export default LinearChart;
